import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AmToasterService } from '@angularminds/am-toaster';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { AuthService } from 'src/app/services/auth.service';
import { FormValidator } from 'src/app/services/form-validator/form-validator';
import { RestService } from 'src/app/services/rest.service';

@Component({
  selector: 'app-change-email',
  templateUrl: './change-email.component.html',
  styleUrls: ['./change-email.component.css']
})
export class ChangeEmailComponent implements OnInit {

  form: FormGroup;
  isButtonDisabled: boolean = false;
  validateStatus: string;
  customErrors: any = {};
  user: any
  isSubmitted: boolean;
  @Output() passEntry: EventEmitter<any> = new EventEmitter();

  constructor(
    private fb: FormBuilder,
    private restService: RestService,
    private authService: AuthService,
    private bsModalRef: BsModalRef,
    public router: Router,
    private amToasterService: AmToasterService,
  ) { }

  ngOnInit() {
    this.buildForm();
  }

  buildForm() {
    this.form = this.fb.group({
      email: ['', [Validators.required]]
    });
  }

  applyValidations() {
    for (const i in this.form.controls) {
      if (this.form.controls.hasOwnProperty(i)) {
        this.form.controls[i].markAsDirty();
        this.form.controls[i].updateValueAndValidity();
      }
    }
  }

  disableWhiteSpace(event) {
    return FormValidator.restrictWhiteSpace(event);
  }

  cancel(): void {
    this.bsModalRef.hide();
  }

  errorMsg
  submitForm(): void {
    this.isSubmitted = true;
    this.applyValidations();
    if (this.form.invalid) {
      return;
    }
    this.isButtonDisabled = true;
    this.restService.put(`/api/users/update/email/${this.user._id}`, { email: this.form.get('email').value }).subscribe((resp: any) => {
      if (resp) {
        this.amToasterService.show("success", "Email update successfully", "Success")
        this.isButtonDisabled = false;
        this.passEntry.emit();
        this.cancel();
      }
    }, error => {
      this.errorMsg = error
      this.form.controls.email.setErrors({ notValid: true });
      this.isButtonDisabled = false;
    })
  }

  get email() {
    return this.form.controls.email;
  }

  get f() {
    return this.form.controls;
  }
}
